import * as React from 'react';
import PropTypes  from 'prop-types';
import Spinner    from 'react-spinkit';

export default class SelectFieldComponent extends React.Component {
	constructor(props) {
		super(props);

		this.state        = { value: props.value }
	}
	
	componentWillReceiveProps(nextProps) {
		this.setState({ value: nextProps.value });
	}

	render() {
		let selectProps = {
			className   : "form-control",
			value       : this.state.value || '',
			disabled    : this.props.disabled,
			id          : this.props.id,
			name        : this.props.name,
			onChange    : this._handleChange,
			placeholder : this.props.placeholder,
			readOnly    : this.props.readOnly,
			required    : this.props.required
		};

		const select = (
			<select {...selectProps}>
				{this.props.nullText && <option disabled value="">{this.props.nullText}</option>}
				{this.props.optGroups
					? this.props.optGroups.map(this._mapOptGroup)
					: (this.props.options && this.props.options.map(this._mapOption))}
			</select>
		);

		const otherwise = this.props.loading || this.props.prefixes.length || this.props.suffixes.length
			? <div className="input-group">
					{this.props.loading && <span className="input-group-addon"><Spinner fadeIn="none" name="wave" /></span>}
					{this.props.prefixes.map((p, i) => <span className="input-group-addon" key={i}>{p}</span>)}
					{select}
					{this.props.suffixes.map((s, i) => <span className="input-group-addon" key={i}>{s}</span>)}
				</div>
			: select;

		if (this.props.label) return (
			<div className="form-group">
				<label className="col-sm-2 control-label" htmlFor={this.props.id}>{this.props.label}</label>
				<div className="col-sm-10">{otherwise}</div>
			</div>
		);

		return otherwise;
	}

	_handleChange = (/** @type {React.SyntheticEvent<Element>} */ event) => {
		this.setState({ value: event.target.value });
		this.props.onChange && this.props.onChange(event);
	}

	_mapOptGroup = (optg) => {
		return (
			<optgroup
			disabled={optg.disabled || false}
			key={optg.label}
			label={optg.label}>
				{optg.options.map(this._mapOption)}
			</optgroup>
		);
	}

	_mapOption = (opt) => {
		return (
			<option
			disabled={opt.disabled || false}
			key={opt.value}
			label={opt.label || null}
			value={opt.value}>
				{opt.text}
			</option>
		);
	}
}

const optionShape = {
	disabled: PropTypes.bool,
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	text: PropTypes.string.isRequired
}

const optGroupShape = {
	disabled: PropTypes.bool,
	label: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(PropTypes.shape(optionShape))
}

SelectFieldComponent.propTypes = {
	disabled   : PropTypes.bool,
	id         : PropTypes.string,
	label      : PropTypes.string,
	name       : PropTypes.string.isRequired,
	nullText   : PropTypes.string,
	onChange   : PropTypes.func,
	options    : PropTypes.arrayOf(PropTypes.shape(optionShape)),
	optGroups  : PropTypes.arrayOf(PropTypes.shape(optGroupShape)),
	placeholder: PropTypes.string,
	prefixes   : PropTypes.array,
	readOnly   : PropTypes.bool,
	required   : PropTypes.bool,
	suffixes   : PropTypes.array,
	value      : PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

SelectFieldComponent.defaultProps = {
	prefixes: [],
	suffixes: []
};


// WEBPACK FOOTER //
// ./src/component/form/select/selectfield-component.js